<div class="modal right" id="newRoute" tabindex="-1" role="dialog" aria-labelledby="newRouteLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="newRouteLabel" ng-if="!route.id">New Route</h4>
                    <h4 id="newRouteLabel" ng-if="route.id">Edit Route</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="saveRoute(route)" class="form-horizontal allcp-form">

										<div class="form-group floating">
											<input id="datetimepicker" 
												date-range-picker
												placeholder="Date" 
												ng-model="route.date"
												type="text" 
												class="form-control  input-md" 
												options="{drops: 'down', singleDatePicker: true, locale: { format: 'MM/DD/YYYY' } }"
												autocomplete="off"
												required>
											<label>Date</label>
										</div>

										<!-- <div class="form-group floating">
											<input 
												date-range-picker
												options="{singleDatePicker: true, timePicker: false, autoApply: true, locale: { format: 'MM/DD/YYYY' } }"
												autocomplete="off" 
												type="text" 
												class="form-control input-md" 
												placeholder="Orders Date" 
												required 
												ng-model="route.date">
											<label>Date</label>
										</div> -->

										<div class="row">
											<div class="col-md-6 pl15">
												<div class="form-group floating">
													<input id="start" autocomplete="off" type="text" class="form-control input-md" placeholder="Start Time" required ng-model="route.scheduled_start">
													<label>Start Time</label>
												</div>
											</div>
											<div class="col-md-6 pr10">
												<div class="form-group floating">
													<input id="end" autocomplete="off" type="text" class="form-control input-md" placeholder="End Time" required ng-model="route.scheduled_end">
													<label>End Time</label>
												</div>
											</div>
										</div>

										<div class="form-group floating mt-2" ng-if="!route.id">
											<div>
												<select id="type" autocomplete="off" class="form-control input-md" name="type" ng-model="route.station_id" required>
													<option value="">Select Station</option>
													<option value="{{ item.id }}" ng-repeat="item in stations">{{ item.code }} - {{ item.city }}</option>
												</select>
												<label>Station</label>
											</div>
										</div>

										<div class="form-group floating">
											<input autocomplete="off" type="number" class="form-control input-md" placeholder="Service Time" required ng-model="route.stop_time">
											<label>Service Time</label>
										</div>

										<div class="row" ng-if="!route.id">
											<div class="col-md-5 pl15">
												<div class="form-group floating mt-2">
													<input type="text" autocomplete="off" class="form-control input-md" placeholder="Number of Route" required ng-model="route.count" ng-disabled="route.id">
													<label>Number of Route</label>
												</div>
											</div>
											<div class="col-md-2 text-center" style="display: flex;align-items: center;">OR</div>
											<div class="col-md-5 pr10">
												<div class="form-group floating mt-2">
													<input autocomplete="off" type="text" class="form-control input-md" placeholder="Deviation" ng-model="route.deviation">
													<label>Deviation</label>
												</div>
											</div>
										</div>

										

										<div class="form-group floating">
											<select id="type" name="type" ng-model="route.vehicle" class="form-control input-md">
												<option value="">Select Vehicle</option>
												<option value="Small">Small</option>
												<option value="Medium">Medium</option>
												<option value="Large">Large</option>
											</select>
											<label>
												Wehicle
											</label>
										</div>
				
										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue">
													<span ng-if="!route.id">CREATE</span>
                    								<span ng-if="route.id">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
